import React, { useState, useRef } from "react";
import DatosMovimientoAlmacen from "./DatosMovimientoAlmacenSalida";
import { notificarError, notificarMsg } from "../Almacenes/AlmacenNotify";
import moment from "moment";
import ModalProveedor from "../clientes/ClienteModal";
import ProveedorNuevo from "../Proveedores/ProveedorNuevo";
import ProveedorSearch from "../Proveedores/ProveedoresListaSearch";

export default function RegistrarSalida({ idAlmacen, onRegistroCompletado, onCancel }) {
    const [proveedor, setProveedor] = useState(null);
    const [items, setItems] = useState([]);
    const [linkedDocument, setLinkedDocument] = useState(null);
    const [modalProveedorIsOpen, setModalProveedorIsOpen] = useState(false);
    const [accionProveedor, setAccionProveedor] = useState(null);
    const [rucProveedor, setRucProveedor] = useState("");
    const [glosa, setGlosa] = useState("");
    const formProveedorRef = useRef({
        IdProveedor: null,
        Ruc: "",
        NomProveedor: "",
        NomContacto: ""
    });

    const handleChangeProveedor = (proveedor) => {
        setProveedor(proveedor);
    }

    const handleClickNuevoProveedor = () => {
        setModalProveedorIsOpen(true);
        setAccionProveedor('NuevoProveedor');
    }

    const handleClickBuscarProveedor = () => {
        formProveedorRef.current = {
            IdProveedor: proveedor?.IdProveedor || null,
            Ruc: proveedor?.Ruc || "",
            NomProveedor: proveedor?.NombreComercial || "",
            NomContacto: ""
        };
        setModalProveedorIsOpen(true);
        setAccionProveedor('BuscarProveedor');
    }

    const handleCloseModalProv = () => {
        if (formProveedorRef.current.IdProveedor && formProveedorRef.current.Ruc) {
            const proveedorActualizado = {
                IdProveedor: formProveedorRef.current.IdProveedor,
                Ruc: formProveedorRef.current.Ruc,
                NombreComercial: formProveedorRef.current.NomProveedor,
                value: `${formProveedorRef.current.IdProveedor}-${formProveedorRef.current.Ruc}`,
                label: formProveedorRef.current.NomProveedor
            };
            setProveedor(proveedorActualizado);
        }
        setModalProveedorIsOpen(false);
    }

    const AsignarValorDoc = (dataProveedor) => {
        const nuevoProveedor = {
            IdProveedor: dataProveedor.IdProveedor,
            Ruc: dataProveedor.Ruc,
            NombreComercial: dataProveedor.RazonSocial,
            value: `${dataProveedor.IdProveedor}-${dataProveedor.Ruc}`,
            label: dataProveedor.RazonSocial
        };
        setProveedor(nuevoProveedor);
        setRucProveedor(dataProveedor.Ruc);
        formProveedorRef.current = {
            IdProveedor: dataProveedor.IdProveedor,
            Ruc: dataProveedor.Ruc,
            NomProveedor: dataProveedor.RazonSocial,
            NomContacto: dataProveedor.Contacto || ""
        };
    }

    const fetchCostos = async (IdPresentacion) => {
        const response = await fetch(`/api/movimientosAlmacen/costo-historico/${IdPresentacion}`);

        if (!response.ok) {
            return [{ Precio: 0 }, { Precio: 0 }, { Precio: 0 }];
        }

        const data = await response.json();
        return data
    };

    const onChangeLinkedDocument = (linkedDocument) => {
        setLinkedDocument(linkedDocument);
    }

    const handleGuardar = async () => {
        if (!proveedor) {
            notificarError("El campo proveedor es requerido.");
            return;
        }

        if (!linkedDocument) {
            notificarError("Verifique que los datos ingresados son válidos.");
            return;
        }

        const req = await fetch("/api/movimientosalmacen/add/", {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                IdMovimientoAlmacen: 1,
                Numero: "",
                FechaRegistro: moment(new Date()).format("YYYY-MM-DD HH:mm"),
                FechaMovimiento: moment(linkedDocument.fechaMovimiento).format("YYYY-MM-DD HH:mm"),
                IdAlmacen: idAlmacen,
                IdTipoDocumentoSunat: linkedDocument.tipoDoc,
                NroDocumentoSunat: null,
                DocInterno: "",
                IdOrdenCompra: null,
                NroOrdenCompra: "",
                Estado: "Sin procesar",
                IdProveedor: proveedor.IdProveedor,
                tipoCambio: 0,
                idCce: null,
                idTipoMov: 2,
                total: 0,
                Glosa: glosa,
            })
        });

        const rpta = await req.json();

        if (
            Array.isArray(rpta) &&
            rpta.length > 0 &&
            Array.isArray(rpta[0]) &&
            rpta[0].length > 0 &&
            Array.isArray(rpta[0][0]) &&
            rpta[0][0].length > 0 &&
            rpta[0][0][0].estado
        ) {
            const movimientoId = rpta[0][0][0].estado;
            onRegistroCompletado(+movimientoId)
        } else {
            notificarError("Error al registrar el movimiento.");
        }
    }

    return <div className="container-fluid" style={{ width: '100%' }}>
        <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <button class="nav-link active" id="nav-info-tab" data-toggle="tab" data-target="#nav-info" type="button" role="tab" aria-controls="nav-info" aria-selected="true">Datos de movimiento</button>
                <button class="nav-link text-muted" id="nav-items-tab" data-toggle="tab" data-target="#nav-items" type="button" role="tab" aria-controls="nav-items" aria-selected="false" disabled>Items</button>
            </div>
        </nav>

        <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade show active" id="nav-info" role="tabpanel" aria-labelledby="nav-info-tab">
                <div className="row">
                    <div className="col-12">
                        <DatosMovimientoAlmacen
                            proveedor={proveedor}
                            handleChangeProveedor={handleChangeProveedor}
                            onChangeLinkedDocument={onChangeLinkedDocument}
                            handleClickNuevoProveedor={handleClickNuevoProveedor}
                            handleClickBuscarProveedor={handleClickBuscarProveedor}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 my-2">
                        <label className="font-weight-bold mt-0">Glosa</label>
                        <textarea
                            className="form-control"
                            rows="3"
                            value={glosa}
                            onChange={(e) => setGlosa(e.target.value)}
                            placeholder="Ingrese observaciones"
                        />
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="nav-items" role="tabpanel" aria-labelledby="nav-items-tab">
            </div>
        </div>

        <div className="d-flex justify-content-between">
            <button type="button" className="btn btn-danger" onClick={onCancel}>Cancelar</button>
            <button type="button" className="btn btn-info" onClick={handleGuardar}>Guardar</button>
        </div>

        {
            accionProveedor === 'NuevoProveedor' ?
                <ModalProveedor 
                    isOpen={modalProveedorIsOpen}
                    onClose={handleCloseModalProv}
                    title="NUEVO PROVEEDOR"
                >
                    <ProveedorNuevo
                        onClose={handleCloseModalProv}
                        NumeroDocumento={rucProveedor}
                        AsignarValorDoc={AsignarValorDoc}
                        sw='oc_nuevo'
                    />
                </ModalProveedor> :
                <ModalProveedor 
                    isOpen={modalProveedorIsOpen}
                    onClose={handleCloseModalProv}
                    title="BUSCAR PROVEEDOR"
                >
                    <ProveedorSearch
                        onClose={handleCloseModalProv}
                        form={formProveedorRef.current}
                    />
                </ModalProveedor>
        }
    </div>
}